<template>
  <v-menu
    v-if="$store.getters.checkUserPrivilege('USER_UPDATE')"
    offset-y
    open-on-hover
    min-width="150px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        text
        v-bind="attrs"
        v-on="on"
      >
        {{ title }}
        <v-icon small>
          mdi-chevron-down
        </v-icon>
      </v-btn>
    </template>

    <v-list dense>
      <template v-for="(option, index) in options">
        <v-list-item
          :key="index"
          :input-value="option.title === title"
          @click="moveTo(option)"
        >
          <v-list-item-title style="cursor: pointer">
            {{ option.title }}
          </v-list-item-title>
        </v-list-item>
        <v-divider
          v-if="index < options.length - 1"
          :key="'divider-' + index"
        />
      </template>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: "UserNavigation",
  data() {
    return {
      title: "Users",
      options: [
        { title: "Users", path: "/users" },
        { title: "Roles", path: "/roles" }
      ]
    };
  },
  methods: {
    moveTo(option) {
      this.title = option.title;
      this.$router.push(option.path);
    }
  }
};
</script>